import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Landing.css";
import React from "react";
import banner from "../../Assets/Images/banner-main.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Navigation, Autoplay } from "swiper/modules";
import Header from "@components/Common/Header/Header";
import Footer from "@components/Common/Footer/Footer";
import partnerShuftiPro from "../../Assets/Images/partner-shuftipro.png";
import partnerCheckMyFile from "../../Assets/Images/partner-checkmyfile.svg";
import partnerEquifax from "../../Assets/Images/partner-equifax.svg";
import partnerStripe from "../../Assets/Images/partner-stripe.svg";

const partners = [
  { name: "Shufti Pro", logo: partnerShuftiPro, description: "Identity Verification" },
  { name: "CheckMyFile", logo: partnerCheckMyFile, description: "Credit Reports" },
  { name: "Equifax", logo: partnerEquifax, description: "Credit Bureau Data" },
  { name: "Stripe", logo: partnerStripe, description: "Secure Payments" },
];
import howItsWorks from "../../Assets/Images/how-it-work.svg";
import whyLendriva from "../../Assets/Images/whylendriva-img.png";
import earbuds from "../../Assets/Images/earbuds.svg";
import bass from "../../Assets/Images/bass.svg";
import profile from "../../Assets/Images/profile-pic-two.png"
import profile1 from "../../Assets/Images/profile-pic.png"
import profile2 from "../../Assets/Images/User.svg"
import profile3 from "../../Assets/Images/Profile-pic2.png"
import profile4 from "../../Assets/Images/profile-pic-four.png"
import profile5 from "../../Assets/Images/profile-pic-five.png"
import profile6 from "../../Assets/Images/profile-pic-six.png"
import profile8 from "../../Assets/Images/profile-pic-eight.png"
import profile9 from "../../Assets/Images/profile-pic-nine.png"






import BannerImg from "../../../public/ban-img-min.png"
import { Link } from "react-router-dom";

const Landing = () => {
  const handleMenuToggle = () => { };
  const reviews1 = [
    {
      id: 1,
      name: "Adeola O.",
      location: "London, UK",
      profile: profile9,
      text: `"I was struggling to get a loan from traditional banks because of my credit history.
Lendriva gave me a chance, and the process was so easy and transparent. I finally feel financially included."`,
    },
    {
      id: 2,
      name: "Raj Patel",
      location: "Leicester, UK",
      profile: profile3,
      text: `"As a small business owner, cash flow can be unpredictable. Lendriva gave me
quick access to funding when I needed it most, without the stress of endless paperwork."`,
    },
    {
      id: 3,
      name: "Charlotte Green",
      location: "Manchester, UK",
      profile: profile5,
      text: `"I decided to try Lendriva as a lender. The platform is clear, I know exactly where
my money is going, and I’m earning better returns than with my savings account. I love the community focus."`,
    },
    {
      id: 4,
      name: "Mateusz Kowalski",
      location: "Birmingham, UK",
      profile: profile,
      text: `"Lendriva made it easy for me to borrow money for unexpected expenses. The
repayment terms were flexible and matched my situation perfectly. I highly recommend it."`,
    },
    {
      id: 5,
      name: "Sophie Martin",
      location: "London, UK",
      profile: profile4,
      text: `"Investing through Lendriva feels different. It’s not just about returns; it’s about
supporting real people. I’ve lent to students, small businesses, and individuals – and I can track every step."`,
    },
    {
      id: 6,
      name: "Andrei Popescu",
      location: "Kent, UK",
      profile: profile6,
      text: `"I joined Lendriva to lend, and I’ve been impressed with the transparency. I can
see the risks, the expected returns, and I feel secure knowing the platform is designed with investors in mind."`,
    },
  ];
  const reviews2 = [
    {
      id: 1,

      name: "Raj Patel",
      location: "Leicester, UK",
      profile: profile3,
      text: `"As a small business owner, cash flow can be unpredictable. Lendriva gave me
quick access to funding when I needed it most, without the stress of endless paperwork."`,
    },

    {
      id: 2,
      name: "Adeola O.",
      location: "London, UK",
      profile: profile9,
      text: `"I was struggling to get a loan from traditional banks because of my credit history.
Lendriva gave me a chance, and the process was so easy and transparent. I finally feel financially included."`,
    },
    {
      id: 3,
      name: "Mateusz Kowalski",
      location: "Birmingham, UK",
      profile: profile3,
      text: `"Lendriva made it easy for me to borrow money for unexpected expenses. The
repayment terms were flexible and matched my situation perfectly. I highly recommend it."`,
    },
    {
      id: 4,
      name: "Charlotte Green",
      location: "Manchester, UK",
      profile: profile2,
      text: `"I decided to try Lendriva as a lender. The platform is clear, I know exactly where
my money is going, and I’m earning better returns than with my savings account. I love the community focus."`,
    },
    {
      id: 5,
      name: "Andrei Popescu",
      location: "Kent, UK",
      profile: profile,
      text: `"I joined Lendriva to lend, and I’ve been impressed with the transparency. I can
see the risks, the expected returns, and I feel secure knowing the platform is designed with investors in mind."`,
    },
    {
      id: 6,
      name: "Sophie Martin",
      location: "London, UK",
      profile: profile2,
      text: `"Investing through Lendriva feels different. It’s not just about returns; it’s about
supporting real people. I’ve lent to students, small businesses, and individuals – and I can track every step."`,
    },

  ];

  const chunkArray = <T,>(arr: T[], size: number): T[][] => {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };
  const groupedReviews1 = chunkArray(reviews1, 3);
  const groupedReviews2 = chunkArray(reviews2, 3);


  return (
    <div>
      {/* Banner Section */}
      <section className="banner-section min-h-section">
        {/* <img src={BannerImg} alt="banner" className="banner-img" /> */}
        <Header handleMenuToggle={handleMenuToggle} />
        <div className="container">
          <div className="banner d-flex row">
            <div className="left-section col-md-6 d-flex flex-column justify-content-center">
              <h1>
                Borrow. <span>Lend.</span> <span>Earn.</span> Instantly
              </h1>
              <p>Peer-to-peer fiat lending made simple, secure, and transparent</p>
              <div className="btn-blk d-flex align-items-center gap-3">
                <Link className="text-decoration-none" to={"/auth/signup"}>
                  <button type="button" className="btn-get-started d-flex align-items-center">
                    Get Started
                  </button>
                </Link>
                <Link to="/auth/login" className="btn-fill-blue">
                  Sign In
                </Link>

              </div>
            </div>
            <div className="right-section col-md-6 text-end">
              <img src={banner} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </section>

      {/* How it Works */}
      <section className="how-lendriva-works text-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 text-start">
              <div className="labels">Simple 3-Step Process</div>
              <h2>How it Works</h2>
              <p className="your-money">
                Your Money, Your Terms — A Smarter Way to Lend and Borrow
              </p>
              <div className="register-block d-flex">
                <div className="num">1</div>
                <div>
                  <h5>Register</h5>
                  <p>Create Your Profile</p>
                </div>
              </div>
              <div className="register-block d-flex">
                <div className="num">2</div>
                <div>
                  <h5>Lend or Borrow</h5>
                  <p>Set your terms or request funds</p>
                </div>
              </div>
              <div className="register-block m-0 d-flex">
                <div className="num">3</div>
                <div>
                  <h5>Earn or Repay</h5>
                  <p>Automated returns or scheduled payments</p>
                </div>
              </div>
              <div className="d-flex justify-content-start">
                <Link className="text-decoration-none" to={"/auth/signup"}>
                  <button className="star">Get Started</button>
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="d-flex h-100">
                <img src={howItsWorks} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Lendriva */}
      <section className="how-lendriva-works why-block">
        <div className="container">
          <h3 className="text-center">Why Lendriva?</h3>
          <p className="text-center">
            Empowering secure, fair, and fast global lending through smart contracts and verified peer connections.
          </p>
          <div className="row bg-white">
            <div className="col-md-5">
              <div className="img-why">
                <img src={whyLendriva} alt="" className="img-fluid" />
              </div>
            </div>
            <div className="col-md-7">
              <div className="why-text-block">
                <h4>Lendriva: Empowering the Future of Peer-to-Peer Lending</h4>
                <p>
                  Experience secure, fair, and borderless lending with smart contracts, user-driven rates, and lightning-fast matching — all in one decentralized platform
                </p>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="d-flex info align-items-start">
                      <img src={earbuds} alt="" className="img-fluid" />
                      <div>
                        <h6>Accessible</h6>
                        <p>We open doors for everyone, regardless of credit history or background.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="d-flex info align-items-start">
                      <img src={bass} alt="" className="img-fluid" />
                      <div>
                        <h6>Transparent</h6>
                        <p className="text">No hidden fees, just clear and honest terms.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="d-flex info align-items-start">
                      <img src={earbuds} alt="" className="img-fluid" />
                      <div>
                        <h6>Flexible</h6>
                        <p>Borrow, lend, or save on your own terms.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="d-flex info align-items-start">
                      <img src={bass} alt="" className="img-fluid" />
                      <div>
                        <h6>Empowering</h6>
                        <p className="text">Every transaction builds stronger financial futures for individuals and
                          communities.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div> {/* ✅ Properly closed why-text-block */}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="how-lendriva-works what-community-says">
        <h3 className="m-0 reviews-heading">
          We have built trust with reviews from real users
        </h3>
        <p>Empowering secure, fair, and fast global lending through smart contracts and verified peer connections.
        </p>

        {/* <Swiper
          slidesPerView={3}
          spaceBetween={30}
          freeMode={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          speed={800}
          loop={true}
          modules={[FreeMode, Pagination, Autoplay]} // ⛔ Navigation removed
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 10 },
            576: { slidesPerView: 2, spaceBetween: 15 },
            768: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 2, spaceBetween: 30 },
            1360: { slidesPerView: 3, spaceBetween: 50 },
            1920: { slidesPerView: 3, spaceBetween: 70 },
          }}
        >
          {[...Array(6)].map((_, i) => (
            <SwiperSlide key={i}>
              <div className="review-box">
                <img src={profile} alt="" className="img-fluid" />
                <h5>“You made it so simple”</h5>
                <div className="person-review">
                  My new site is so much faster and easier to work with than my old site.
                </div>
                <div className="review-inner d-flex align-items-center flex-column justify-content-center">
                  <h6>Adeola O.</h6>
                  <p className="m-0 designation">London, UK</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper> */}
        <Swiper
          slidesPerView={3}
          spaceBetween={30}
          freeMode={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          speed={800}
          loop={true}
          modules={[FreeMode, Pagination, Autoplay]}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 10 },
            576: { slidesPerView: 2, spaceBetween: 15 },
            768: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 2, spaceBetween: 30 },
            1360: { slidesPerView: 3, spaceBetween: 50 },
            1920: { slidesPerView: 3, spaceBetween: 70 },
          }}
        >
          {reviews1.map((review) => (
            <SwiperSlide key={review.id}>
              <div className="review-box">
                <img src={review.profile} alt={review.name} className="img-fluid" />
                <div className="person-review">{review.text}</div>
                <div className="review-inner d-flex align-items-center flex-column justify-content-center">
                  <h6>{review.name}</h6>
                  <p className="m-0 designation">{review.location}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </section>

      {/* Partners */}

      <section className="patner-lendrive">
        <div className="container">
          <h3>Our Partners</h3>
          <p>
            We work with trusted third-party providers for identity verification,
            credit assessment, and secure payments:
          </p>
        </div>
        <div className="partners-marquee" aria-label="Partner logos">
          <div className="partners-marquee-track">
            {[0, 1].map((copy) => (
              <ul
                key={copy}
                className="partners-marquee-list"
                aria-hidden={copy === 1 ? true : undefined}
              >
                {[...partners, ...partners, ...partners].map((partner, index) => (
                  <li
                    key={`${copy}-${partner.name}-${index}`}
                    className="partner-logo-item"
                  >
                    <div className="partner-logo-wrap">
                      <img
                        src={partner.logo}
                        alt={copy === 0 && index < partners.length ? partner.name : ""}
                        className="partner-logo"
                        draggable={false}
                      />
                      <div className="partner-hover-detail" role="tooltip">
                        <span className="partner-hover-name">{partner.name}</span>
                        <span className="partner-hover-desc">{partner.description}</span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </section>

      {/* Borrow */}

      <section className="borrow-section borrow-img">
        <div className="container">
          <div className=" text-center borrow-img">
            <h2 className="mt-0">Ready to Lend or Borrow?</h2>
            <p>Start building your financial future today</p>
            <div className="input-bloc text-center">
              <input type="email" placeholder="Enter Your Email" />
              <button className="btn-filled-blue-lan">
                Subscribe
              </button>
              <p className="text-center m-0 borrow-para">We’ll never share your details with third parties.
                View our Privacy Policy for more info.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Landing;
